import { callAPI, HTTPMethod } from './API'
import { SecureFileRequest, SecureFileResponse } from '../model'

const secure = async (
    request: SecureFileRequest
): Promise<SecureFileResponse> => {
    return await callAPI('/files/secure', {
        method: HTTPMethod.POST,
        body: request,
    })
}

export { secure }
